module.exports = __webpack_public_path__ + "static/media/juliaw.fbb6dc3e.jpg";